function prepareSliders() {
    //return;

    // Alle Multiboxelemente mit der Klasse Slider(N) jeweils zusammenführen
    var hHelper = 0;
    var xHelper = 0;
    var q = 1;
    var $sliderHelper;
    var cClasses;


    $('.vi-uf-sliderBox').each(function (index, value) {
        var singleSlide =  true;
        if($('.slide',this).length>1){
            singleSlide = false;
        }
        sliderId = '#'+ $(this).attr('id');
            var that = $(this);
            myInterval = setInterval(function() {
                $(that).css({'max-width': parseInt($('.maskImg').width()) + 'px'});
                if (parseInt($('.maskImg').width())>0) {
                    $('.vi-uf-sliderButtons .sliderButton').removeClass('selected');
                    $('.vi-uf-sliderButtons .sliderButton').first().addClass('selected');

                    clearInterval(myInterval);
                    sliderNumber = $(that).attr('data-tag-elem-nr');
                    sliderButtons = '#sliderButtonContainer' + sliderNumber + ' .sliderButton';
                    sliderArrows = '#sliderArrowContainer' + sliderNumber;
                    initSlider(sliderId, sliderButtons, sliderArrows, singleSlide);
                }
            },80);

    });
}

function initSlider(_sliderId, _sliderButton, _arrowCont, _singleSlide){
//function initSlider(_sliderId){
    if(_singleSlide){
        // $(_sliderButton).hide();
        $(_sliderId).iosSlider({
            snapToChildren: true,
            scrollbar: false,
            scrollbarDrag: false,
            scrollbarHeight: '15px',
            autoSlide: false,
            desktopClickDrag: true,
            infiniteSlider: true,
            responsiveSlideContainer: true,
            responsiveSlides: true,
            onSliderLoaded: slideLoadedSingle
        });

    }else {
        $(_sliderButton).show();
        $(_sliderId).iosSlider({
            snapToChildren: true,
            scrollbar: false,
            scrollbarDrag: false,
            scrollbarHeight: '15px',
            navSlideSelector: $(_sliderButton),
            navPrevSelector: $(_arrowCont + ' .slideLeft'),
            navNextSelector: $(_arrowCont + ' .slideRight'),
            autoSlide: true,
            autoSlideTimer: 9000,
            autoSlideTransTimer: 1000,
            desktopClickDrag: true,
            infiniteSlider: true,
            responsiveSlideContainer: true,
            responsiveSlides: true,
            startAtSlide: 1,
            onSliderLoaded: slideLoaded,
            onSlideChange: slideChange,
            onSlideComplete: slideComplete,
            autoSlideToggleSelector: $('.sliderMask')
        });
    }
}

function sliderUpdate(args) {
    args.sliderObject.iosSlider('update');
}


function slideLoaded(args) {
    setTimeout(function(){
        // $('#'+args.sliderContainerObject.attr('id')).iosSlider('autoSlidePlay');
        $('.headInnerContent').html($(args.currentSlideObject).data('head-content'));
    },500);

}

function slideLoadedSingle(args) {
    setTimeout(function(){
        // $('#'+args.sliderContainerObject.attr('id')).iosSlider('autoSlidePlay');
        $('.headInnerContent').html($(args.currentSlideObject).data('head-content'));
    },500);
    if($(args.currentSlideObject).find('.innerVideo').length > 0){
        var mediaVideo = $(args.currentSlideObject).find('.innerVideo').get(0);
        setTimeout(function(){
            mediaVideo.play();
        },200);

    }

}

function slideChange(args) {
    $('.headInnerContent').toggle(10).parent().removeClass('show');
    if($(args.currentSlideObject).find('.innerVideo').length > 0){
        var mediaVideo = $(args.currentSlideObject).find('.innerVideo').get(0);
            mediaVideo.pause();

    }

    $('#sliderButtonContainer'+args.sliderContainerObject.attr('data-tag-elem-nr')+' .sliderButton').removeClass('selected');
    $('#sliderButtonContainer'+args.sliderContainerObject.attr('data-tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
}
function slideComplete(args) {
    $('.headInnerContent').html($(args.currentSlideObject).data('head-content')).toggle(10).parent().addClass('show');

    if($(args.currentSlideObject).find('.innerVideo').length > 0){
        var mediaVideo = $(args.currentSlideObject).find('.innerVideo').get(0);
        setTimeout(function(){
            mediaVideo.play();
        },200);

    }
}

//alte Funktion noch nicht angepasst!!
/*function slideAnimate() {

    $('.sliderWrapper,.arrowContainer').mouseover(function(){
        $('.arrowContainer').css('opacity','0');
        $('.'+$(this).attr('id')+'.arrowContainer').css('opacity','1').off().on('mouseout',function(){
            $('.'+$(this).attr('id')+'.arrowContainer').css('opacity','0');
        });
    });
    $('.sliderWrapper').mouseout(function(){
        $('.'+$(this).attr('id')+'.arrowContainer').css('opacity','0');
    });



        $('#sliderWrapper1, #arrowContainer1').mouseover(function(){
            $('#arrowContainer1').css('opacity','1');
        });
        $('#sliderWrapper1').mouseout(function(){
            $('#arrowContainer1').css('opacity','0');
        });

}*/
